import React, {ReactElement, Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {withRouter} from "react-router-dom";
import {LoadingOutlined, StopOutlined} from '@ant-design/icons';


const RectangleCardItem = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)>=>{

    const {value, name} =props;

    const showIcon = ()=>{
        switch (value) {
            case 'loading': return <LoadingOutlined spin/>;
            case 'noData': return <StopOutlined/>;
            case 'unlimited': return <span style={{fontSize: '14px'}}><FormattedMessage id={'unlimited'}/></span>;
            default: return value;
        }
    };

    return(
        <div className={'rectangle-card-item'}>
            <div>
                <p className={'text-ellipsis'}>{showIcon()}</p>
                <p className={'text-ellipsis'}><FormattedMessage id={name||''}/></p>
            </div>
        </div>
    )
};

export default withRouter(RectangleCardItem);
